module.exports = __webpack_public_path__ + "img/ic-ext-link.540504c2.svg";